import Component from 'component';
import '../plugins/jquery.event.move';
import '../plugins/jquery.twentytwenty';

class FeaturedCompare extends Component {
  constructor(el) {
    super(el);

    this.$el.twentytwenty({
      default_offset_pct: 0.5,
      no_overlay: true,
      onMove: ::this.onMove
    });

    this.$el.find('.twentytwenty-right-arrow').hide();
  }

  onMove(position) {
    if (position < 0.05) {
      this.$el.find('.twentytwenty-left-arrow').hide();
      this.$el.find('.twentytwenty-right-arrow').show();
    } else {
      this.$el.find('.twentytwenty-left-arrow').show();
      this.$el.find('.twentytwenty-right-arrow').hide();
    }
  }

}

export default FeaturedCompare;



// WEBPACK FOOTER //
// ./src/bb/js/components/FeaturedCompare.js